/* unplugin-vue-components disabled */import { render } from "./SpocCourseCard.vue?vue&type=template&id=c92539b6&scoped=true"
import script from "./SpocCourseCard.vue?vue&type=script&lang=js"
export * from "./SpocCourseCard.vue?vue&type=script&lang=js"

import "./SpocCourseCard.vue?vue&type=style&index=0&id=c92539b6&lang=scss&scoped=true"

import exportComponent from "/root/.jenkins/workspace/外网-成都工业学院-前台页面/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c92539b6"]])

export default __exports__